import { layoutMap } from '@nextiva/engagement-ui';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import SocialIcon from 'components/SocialIcon';
import StylingToCSSLabelText from 'styling/hocs/StylingToCSS/StylingToCSSLabelText';
import propTypeStyleLabel from 'styling/config/editorBlock/PropTypes/styleLabel';
import socialMediaList from 'sharedParts/config/socialMediaConfig';
import { socialButtonsArrayPropType } from './socialQuestionPropTypes';

import styles from './SocialQuestion.scss';

/* set a new anchor value of a social button label being edited */
const updateButtonAnchor = (buttons, editedButton) => {
  return buttons.map(
    btn =>
      btn.value === editedButton.value
        ? {
            ...btn,
            anchor: editedButton.anchor,
          }
        : btn,
  );
};

const SocialQuestion = ({
  block: { display, layout, alignment, buttons, display: showLabel },
  readOnly,
  styleLabel,
  isInPreviewMode,
  onEdit,
}) => (
  <div data-e2e="social-block">
    <div className={cx(styles.content, styles[layout], styles[alignment])}>
      {buttons.map(button => {
        return (
          <SocialIcon
            key={`social-icon-${button.value}`}
            button={button}
            showText={display}
            disabled={readOnly}
            showLabel={showLabel}
            config={socialMediaList[button.value]}
            isFullWidthLabel={layout === layoutMap.vertical}
            styleLabel={styleLabel}
            editable={Boolean(!isInPreviewMode && onEdit)}
            onSubmit={editedButton => {
              onEdit({
                buttons: updateButtonAnchor(buttons, editedButton),
              });
            }}
          />
        );
      })}
    </div>
  </div>
);

SocialQuestion.propTypes = {
  block: PropTypes.shape({
    layout: PropTypes.string,
    alignment: PropTypes.string,
    display: PropTypes.bool,
    buttons: socialButtonsArrayPropType.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  styleLabel: propTypeStyleLabel,
  onEdit: PropTypes.func,
};

export default StylingToCSSLabelText(SocialQuestion);
